import sharedStyles from 'styles/css/SharedStyles.module.scss';
import ShortHeaderWithBackBtn from 'components/root/partials/header/ShortHeaderWithBackBtn';
import formStyles from 'styles/css/FormStyles.module.scss';
import ruleStyles from 'styles/css/RuleStyles.module.scss';
import { useDispatch, useSelector } from "react-redux";
import { handleChangeDataVipServicesPage } from "reduxx/actions/pages/vipServices";
import { handleSetOpenCustomSnackbar } from 'reduxx/actions/snackbar';
import apiRequest from 'utils/apiRequest';
import { VIP_SERVICES_REQUEST } from 'apis'; 
// import CheckBoxIcon from '@mui/icons-material/CheckBox';

const Investment = () => {

    const dispatch = useDispatch();

    const { inputFullname, inputMobile } = useSelector(state => state.vipServices);
    const { isBackdropLoading } = useSelector(state => state.allLoaders);

    const handleChangeInputs = (event) => {
        const {name, value} = event.target;
        if(name === 'inputMobile')
            dispatch(handleChangeDataVipServicesPage(name, value));
        else
            dispatch(handleChangeDataVipServicesPage(name, changeNumberPersianAndArabic(value)));
    };

    const changeNumberPersianAndArabic = (str) => {
        let
            persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g],
            arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g];
        if (typeof str === 'string') {
            for (let i = 0; i < 10; i++) {
                str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
            }
        }
        return str;
    };


    return (
        
        <div className={sharedStyles.container} id={ruleStyles['rules-page']}>

            <div className={[sharedStyles['container-padding'], sharedStyles['pb-[64px]']].join(' ')}>
                <ShortHeaderWithBackBtn />
                

                <div className={[formStyles.title, formStyles['text-center'], formStyles['!text-primary']].join(' ')}>
                    فرصت سرمایه گذاری در Dr20
                </div>

                <p className={ruleStyles['text-justify']}>
                    بسم‌الله الرحمن الرحیم
                </p>

                <p className={ruleStyles['text-justify']}>
                    شرکت فن آوران و نوآوران دکتر بیست به شماره ثبت 65751 و شماره ملی 14014765484 به منظور توسعه زیرساختها و تبلیغات، قصد واگذاری 5% تا 10% از سهام خودرا به هلدینگ ها ،بانک ها و تجار دارد.
                </p>



                <div className={[formStyles['title-2'], formStyles['text-right']].join(' ')} style={{marginBottom: '8px'}}>
                    مزایا:
                </div>

                <p className={ruleStyles['text-justify']}>
                    ۱- انتقال سهام در اداره ثبت شرکتهای شیراز صورت می‌گیرد.
                </p>

                <p className={ruleStyles['text-justify']}>
                    ۲- سهام شرکت توسط کارشناس رسمی دادگستری فیلدمجازی(دارای دکترای آی تی و دکترای حقوق) ارزش گذاری شده است.
                </p>

                <p className={ruleStyles['text-justify']}>
                    ۳- میزان سهام خریداری شده، بصورت سندملکی
                     و ضمانت ارزی اسکناس یا 
                    (BANK NOTE or CASH )
                    تضمین می‌شود ودر سندخرید سهام، درج میشود. 
                </p>

                <p className={ruleStyles['text-justify']}>
                    ۴- شرکت Dr20، تعهد پرداخت سود خالص پایان سال مالی 
                    (NET PROFIT)
                    و تعهد استخدامی به میزان سهام خریداری شده را دارد..
                </p>

                <p className={ruleStyles['text-justify']}>
                    <span style={{marginLeft: "5px"}}>✅</span>
                    توجه: درصد دوم‌ ( 1240 سهم دوم ) 
                    و درصد سوم ( 1240 سهم سوم ) 
                    از سهام مذکور، 
                    با 70٪ درصد تخفیف 
                    (فقط بمدت محدود= دو ماه) واگذار می‌شود.
                    قابل معاوضه و تهاتر با خودرو یا آپارتمان
                     (حتی خودرو یا ملک گرانقیمت)
                </p>


                <p className={ruleStyles['text-justify']}>
                    {/*<CheckBoxIcon sx={{ color: 'green', fontSize: 40 }} />*/}
                    <span style={{marginLeft: "5px"}}>✅</span>
                    جهت مذاکره خرید سهام ، بصورت حضوری به آدرس: شیراز، تاچارا،بلوار بهشت، مجتمع تجاری ارکیده، واحد 18 مراجعه بفرمایید(لطفا قبل از مراجعه،،هماهنگی ساعت ملاقات
                    درواتس آپ، صورت گیرد)
                </p>
                

            </div>
                
        </div>

    );
}

export default Investment;